import {datadogRum} from '@datadog/browser-rum';
import type {EnvNameV3} from '@smart/endpoint-directory';
import {hasUserConsentedToCookies} from './utils/client/consent';

export const getTracingUrl = (url: string) =>
  new RegExp(
    `^https:\/\/(preview.)?((dev|sit|stage).)?[a-z]{2}.smart.com\/?.*$`,
  ).test(url) || //website
  new RegExp(`^https:\/\/((dev|sit|stage).)?id.smart.com\/?.*$`).test(url) || //adb
  new RegExp(
    `^https:\/\/([a-z]{2}.)?((dev|qa).)?adb.(srv.)?smart.com\/?.*$`,
  ).test(
    url, //login
  );

const getTrackingConsent = () => {
  return hasUserConsentedToCookies() ? `granted` : `not-granted`;
};

export const setupDatadogBrowserRum = (
  envName: EnvNameV3,
  preview: boolean,
): void => {
  if (window.location.hostname === `localhost`) {
    console.info(`Datadog Browser RUM is disabled on localhost`);
    return;
  }

  try {
    if (preview || envName !== `prod`) {
      console.info(`Datadog Browser RUM initializing...`);
      console.info(`Datadog Browser RUM envName: ${envName}`);
      console.info(`Datadog Browser RUM version: ${process.env.VERSION}`);
      console.info(
        `Datadog Browser RUM trackingConsent: ${getTrackingConsent()}`,
      );
    }

    datadogRum.init({
      applicationId: `a4a1b504-6849-42f5-ae23-0f8254c3b1e1`,
      clientToken: `pub2d3c65be1d1ec32792c7891a955d130a`,
      site: `datadoghq.eu`,
      service: `website`,
      env: envName,
      version: process.env.VERSION!,
      enableExperimentalFeatures: [`feature_flags`],
      sessionSampleRate: 100,
      sessionReplaySampleRate: 0,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: `mask-user-input`,
      trackingConsent: getTrackingConsent(),
      allowedTracingUrls: [getTracingUrl],
    });
    if (window !== undefined) {
      window.addEventListener(`onetrustConsentChange`, () => {
        console.info(
          `Datadog Browser RUM trackingConsent: ${getTrackingConsent()}`,
        );
        datadogRum.setTrackingConsent(getTrackingConsent());
      });
    }
  } catch (error) {
    console.warn(
      `Datadog Browser RUM failed to initialize: ${JSON.stringify(error)}`,
    );
  }
};
